module.exports = __webpack_public_path__ + "img/sxdl.6292696f.png";